import Home from '../Home/Home';
import Features from '../Features/Features';
import Gallery from '../Gallery/Gallery';
import Download from '../Download/Download';
import Booking from '../Booking/Booking';
import HowItWork from '../HowItWork/HowItWork';
import FeaturesTab from '../FeaturesTab/FeaturesTab';
import Contact from '../Contact/Contact';

const Landingpage = (props) => {
    return (
        <>
            <Home />
            <Features />
            <FeaturesTab />
            <HowItWork />
            <Gallery />
            <Contact />
            <Download />
            <Booking />
        </>
    );
};

export default Landingpage;